<template>
  <text-input
    class="password-input"
    :id="id"
    :type="type"
    v-model="localValue"
    :label="label"
    :required="required"
    :disabled="disabled"
    maxlength="28"
  >
    <icon-button
      class="show-hide"
      tabindex="-1"
      :icon="`${type === 'password' ? 'visibility' : 'visibility_off'}`"
      @click="toggleType"
    />
  </text-input>
</template>

<script>
import IconButton from './IconButton';
import TextInput from './TextInput';

export default {
  components: {
    IconButton,
    TextInput,
  },

  props: {
    value: [String, Number],
    id: String,
    label: String,
    required: Boolean,
    disabled: Boolean,
  },

  data() {
    return {
      localValue: this.value,
      type: 'password',
    };
  },

  watch: {
    value(value) {
      this.localValue = value;
    },

    localValue(value) {
      this.$emit('input', value);
    },
  },

  methods: {
    toggleType() {
      this.type = this.type === 'password' ? 'text' : 'password';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.show-hide {
  --theme-icon-button-color: #{$color-gray-5};
}
</style>
